// extracted by mini-css-extract-plugin
var _1 = "vXgX5";
var _2 = "O9eak";
var _3 = "OULu9";
var _4 = "Ra4aw";
var _5 = "iaaGf";
var _6 = "v5P8e";
var _7 = "ppTHM";
var _8 = "j6MX3";
var _9 = "h47QA";
var _a = "UsNCm";
var _b = "psOcJ";
var _c = "NAxFL";
var _d = "MnAbX";
var _e = "aKffY";
var _f = "yiqql";
var _10 = "pqFXs";
var _11 = "RamAZ";
var _12 = "Bu6wx";
var _13 = "_8air";
var _14 = "RLl0o";
export { _1 as "button", _2 as "button-base", _3 as "destructive", _4 as "has-icon-only", _5 as "is-active", _6 as "is-disabled", _7 as "is-full-width", _8 as "is-processing", _9 as "large", _a as "link", _b as "medium", _c as "mint", _d as "outline", _e as "primary", _f as "secondary", _10 as "small", _11 as "spinner", _12 as "teal", _13 as "timer", _14 as "tiny" }
